<script lang="ts" setup>
import { type DefineComponent, onMounted, ref } from 'vue'
import ShikiCode from '@/components/product-shared/constants/authentication.cy?shiki'
import ShikiCodeSsr from '@/components/product-shared/constants/authentication.cy?shiki-ssr'
import useTypewriter from '@/utilities/useTypewriter'
import EditorFileTree from '@/components/product-shared/EditorFileTree.vue'
import fileTree from '../constants/heroEditorFileTree.json'
import useMounted from '@/utilities/useMounted'

const shikiCode = ref<DefineComponent>()
const mounted = useMounted()
const typing = ref(false)

const callback = () => {
  emit('done')
}

const { type, reset } = useTypewriter()

onMounted(() => {
  if (shikiCode.value) {
    reset(shikiCode.value.$el)
    setTimeout(() => {
      typing.value = true
      type(callback)
    }, 1500)
  }
})

const emit = defineEmits(['done'])
</script>

<template>
  <div class="flex h-[256px] w-[120%] bg-[#131626] sm:h-[338px] sm:w-full md:h-[380px] lg:h-[500px] xl:h-[600px]">
    <div class="hidden w-[240px] shrink-0 border-r-[1px] border-gray-900 p-[8px] lg:block">
      <EditorFileTree :file-tree="fileTree" />
    </div>
    <ShikiCode
      v-show="mounted"
      ref="shikiCode"
      class="scale-80 editing w-[5000px] origin-top-left transform overflow-x-auto p-[8px] text-[10px] leading-[14px] sm:w-auto sm:scale-100 sm:text-[13px] sm:leading-[18px] md:p-[16px] md:text-[13px] md:leading-[20px]"
    />
    <ShikiCodeSsr
      v-show="!mounted"
      class="editing overflow-x-hidden p-[8px] text-[10px] leading-[14px] sm:text-[13px] sm:leading-[18px] md:p-[16px] md:text-[14px] md:leading-[20px]"
    />
  </div>
</template>

<style>
.editing.shiki code > span.line:last-child > span:last-child:after {
  content: '|';
  animation: blink 1s steps(2) infinite;
  position: absolute;
  color: white;
  font-weight: bold;
}

@keyframes blink {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
</style>

<style scoped>
div ::v-deep(span.line::before) {
  @apply ml-3;
}
div ::v-deep(span.line) {
  @apply pl-4;
}
</style>
